import { render } from "./TrashCan.vue?vue&type=template&id=030062f4"
import script from "./TrashCan.vue?vue&type=script&lang=js"
export * from "./TrashCan.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TrashCan.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "030062f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('030062f4', __exports__)) {
    api.reload('030062f4', __exports__)
  }
  
  module.hot.accept("./TrashCan.vue?vue&type=template&id=030062f4", () => {
    api.rerender('030062f4', render)
  })

}


export default __exports__